// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3yeho","header":"ClearentDisclaimer_header__1H8wj","inner":"ClearentDisclaimer_inner__1mTNd"};